module.exports = __webpack_public_path__ + "static/media/Trash.6d90416f.svg";